//  360px以下対応
!(function () {
  const viewport = document.querySelector('meta[name="viewport"]');
  function switchViewport() {
    const value =
      window.outerWidth > 360
        ? 'width=device-width,initial-scale=1'
        : 'width=360';
    if (viewport.getAttribute('content') !== value) {
      viewport.setAttribute('content', value);
    }
  }
  addEventListener('resize', switchViewport, false);
  switchViewport();
})();
//  360px以下対応

if(!location.hash.match('#')) {
  window.scrollTo({
    top: 0,
  });
}

document.addEventListener('DOMContentLoaded', ()=>{
  // drawer
  const hamburger = document.querySelector('.ergolo-sp-hamburger');
  const drawer = document.querySelector('.ergolo-sp-drawer');
  const drawer_close = document.querySelectorAll('.js-drawer-close');
  hamburger.addEventListener('click', ()=>{
    drawer.classList.add('is-open');
  });
  drawer_close.forEach((elm)=>{
    elm.addEventListener('click', ()=>{
      drawer.classList.remove('is-open');
    });
  });
  
  let loading_time = 2000;
  // initialize animation
  const animated = document.querySelectorAll('.slide-in-title, .is-revealed');
  animated.forEach((elm)=>{
    if(elm.classList.contains('slide-in-title')) {
      elm.removeAttribute('style');
    }
    if(elm.classList.contains('is-revealed')) {
      elm.classList.remove('is-revealed');
    }
  });

  // loading
  setTimeout(()=>{
    if(!location.hash.match('#')) {
      window.scrollTo({
        top: 0,
      });
    }
    const loading = document.querySelector('.ergolo-loading');
    loading.classList.add('loaded');
  } , loading_time);
  // loading
  
  // anchor
  const anchors = document.querySelectorAll('a');
  if(anchors != null) {
    anchors.forEach((a)=>{
      if(a.getAttribute('href').match('#') && a.getAttribute('href').length > 1) {
        a.addEventListener('click', (e)=>{
          e.preventDefault();
          const header_heigt = document.querySelector('.header').clientHeight;
          const target = document.querySelector(a.getAttribute('href')).getBoundingClientRect().top - header_heigt;
          window.scrollBy({
            behavior: "smooth",
            top: target,
          });
          history.pushState(null, null, a.getAttribute('href'))
        }, true);
      }
    });
  }
  if(location.hash.match('#')) {
    const header_heigt = document.querySelector('.header').clientHeight;
    const target = document.querySelector(location.hash);
    if(target != null) {
        window.scrollTo({
          top: target.getBoundingClientRect().top - header_heigt,
        });
    }
  }
  // anchor
  
  // main-fv
  const swiper = new Swiper('.main-fv', {
    loop: true,
    autoplay: {
     delay: 5000,
   },
    pagination: {
    el: '.swiper-pagination',
    },
  });
  // main-fv

  // top button
  const top_button = document.querySelector('#ergolo-top');
  if(top_button != null) {
    top_button.addEventListener('click', ()=>{
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });
  }
  // top button
  
  // intersection observer animations
  
  const intersection_targets = document.querySelectorAll('.intersection-target');

    // initialize parallax
  setTimeout(()=>{
    const parallax_targets = document.querySelectorAll('.parallax');
    if(parallax_targets != null) {
      let prl_id = 0;
      for(let i in parallax_targets) {
        if(typeof parallax_targets[i] == 'object') {
          if(parallax_targets[i].classList.contains('parallax-from-bottom')) {
            parallax_targets[i].style.transform = `translateY(${parallax_targets[i].dataset.distance}px)`;
            parallax_targets[i].style.transition = 'transform .15s';
          }
          if(parallax_targets[i].classList.contains('parallax-from-right')) {
            parallax_targets[i].style.transform = `translateX(${parallax_targets[i].dataset.distance}px)`;
            parallax_targets[i].style.transition = 'transform .15s';
          }
          
          if(parallax_targets[i].classList.contains('parallax-from-left')) {
            parallax_targets[i].style.transform = `translateX(-${parallax_targets[i].dataset.distance}px)`;
            parallax_targets[i].style.transition = 'transform .15s';
          }
          const prl_img = parallax_targets[i].querySelectorAll('img');
          prl_img.forEach((img)=>{
            if(parallax_targets[i].dataset.scale != null) {
              img.style.transform = `scale(${parallax_targets[i].dataset.scale})`;
            }
          });
          parallax_targets[i].setAttribute('id', `prl${prl_id}`);
          prl_id += 1;
        }
      }
    }
  }, loading_time);

  let prl_flags = {};
  function callback(entries, object) {
      entries.forEach(function(entry, i) {        
          const elm = entry.target;
        
          if(elm.classList.contains('reveal-text')) {
            if (entry.isIntersecting) {
              elm.classList.add('is-revealed');
              object.unobserve(elm);
            }
          }
        
          if(elm.classList.contains('reveal-images')) {
            if (entry.isIntersecting) {
              elm.classList.add('is-revealed');
              object.unobserve(elm);
            }
          }
        
          if(elm.classList.contains('slide-in-title')) {
            if (entry.isIntersecting) {
              elm.style.maxWidth = `${elm.querySelector('.section-title').clientWidth}px`;
              object.unobserve(elm);
            }
          }
        
          if(elm.classList.contains('reveal-from-bottom')) {
            if (entry.isIntersecting) {
              elm.classList.add('is-revealed');
              object.unobserve(elm);
            }
          }
        
          if(elm.classList.contains('reveal-from-left')) {
            if (entry.isIntersecting) {
              elm.classList.add('is-revealed');
              object.unobserve(elm);
            }
          }
        
          if(elm.classList.contains('reveal-from-right')) {
            if (entry.isIntersecting) {
              elm.classList.add('is-revealed');
              object.unobserve(elm);
            }
          }
        
          if(elm.classList.contains('parallax')) {
            if (entry.isIntersecting) {
              prl_flags[elm.getAttribute('id')] = true;
            } else {
              prl_flags[elm.getAttribute('id')] = false;
            }
          }
      });
  };
  
  const options = {
      root: null,
      rootMargin: "0px 0px",
      threshold: 0
  };
  
  const observer = new IntersectionObserver(callback, options);
  
  intersection_targets.forEach((elm)=>{
      observer.observe(elm);
  });
  
  let scroll_amount = 0;
  window.addEventListener('scroll', (e)=>{

    // top button
    scroll_amount = window.pageYOffset;
    if(scroll_amount > window.innerHeight) {
      top_button.classList.add('is-visible');
    } else {
      top_button.classList.remove('is-visible');
    }
    // top button
    
    for(let key in prl_flags) {
      if(prl_flags[key]) {
        const target = document.querySelector(`#${key}`);
        if(target != null) {
          // パララックス共通変数
          const from_top = target.getBoundingClientRect().top + window.scrollY - window.innerHeight;
          const amount = window.pageYOffset - from_top;
          // 左スクロール
          if(target.classList.contains('parallax-left')) {
            const imgs = target.querySelectorAll('img');
            if(imgs != null) {
              imgs.forEach((img)=>{
                const max_move_ratio = (target.clientWidth * (Number(target.dataset.scale) - 1)) / (target.clientHeight + window.innerHeight);
                img.style.transform = `scale(${target.dataset.scale}) translateX(-${amount * max_move_ratio}px)`;
              });
            }
          }
          // 右スクロール
          if(target.classList.contains('parallax-right')) {
            const imgs = target.querySelectorAll('img');
            if(imgs != null) {
              imgs.forEach((img)=>{
                const max_move_ratio = (target.clientWidth * (Number(target.dataset.scale) - 1)) / (target.clientHeight + window.innerHeight);
                img.style.transform = `scale(${target.dataset.scale}) translateX(${amount * max_move_ratio}px)`;
              });
            }
          }
          // 上スクロール
          if(target.classList.contains('parallax-top')) {
            const imgs = target.querySelectorAll('img');
            if(imgs != null) {
              imgs.forEach((img)=>{
                const max_move_ratio = (target.clientHeight * (Number(target.dataset.scale) - 1)) / (target.clientHeight + window.innerHeight);
                img.style.transform = `scale(${target.dataset.scale}) translateY(-${amount * max_move_ratio}px)`;
              });
            }
          }
          // スクロールで拡大
          if(target.classList.contains('parallax-zoom-up')) {
            const imgs = target.querySelectorAll('img');
            if(imgs != null) {
              imgs.forEach((img)=>{
                Number(target.dataset.zoom_ratio)
                const scroll_per_ratio = (Number(target.dataset.zoom_ratio) - 1) / (target.clientHeight + window.innerHeight);
                img.style.transform = `scale(${1 + (scroll_per_ratio * amount)})`;
              });
            }
          }
          // 要素自体が動く場合の共通変数
            const distance = Number(target.dataset.distance);
            let offset = 0;
            if(target.dataset.offset != null) {
              offset = Number(target.dataset.offset);
            }

          let speed_offset = 2;
          if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
            speed_offset = 1.5;
          }
          console.log(speed_offset);
          
          // 下から現れる
          if(target.classList.contains('parallax-from-bottom')) {
            let range = distance -  (speed_offset * 2 * amount * (distance - offset) / (target.clientHeight + window.innerHeight));
            if(range < 0) {
              range = 0;
            }
            target.style.transform = `translateY(${range}px)`;
          }
          // 右から現れる
          if(target.classList.contains('parallax-from-right')) {
            let range = distance -  (speed_offset * 2 * amount * (distance - offset) / (target.clientHeight + window.innerHeight));
            if(range < 0) {
              range = 0;
            }
            target.style.transform = `translateX(${range}px)`;
          }
          // 左から現れる
          if(target.classList.contains('parallax-from-left')) {
            let range = -distance +  (speed_offset * 2 * amount * (distance - offset) / (target.clientHeight + window.innerHeight));
            if(range > 0) {
              range = 0;
            }
            target.style.transform = `translateX(${range}px)`;
          }
        }
      } else {
      }
    }
    
  }, true);
  // intersection observer animations
  
});
